import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormSelect } from 'react-bootstrap';
import JobDataService from "./services/job.service";
import { Navigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useEffect } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import SearchClient from './SearchClient';
import { NewHeader, PageHeader } from './AuxiliaryFunctions';
import TopAndSideBar from './TopAndSideBar';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditJobsPage = (props) => {    
  let params = useParams();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [jobid, setJobid] = useState(params.id);
  const [jobtitle, setJobtitle] = useState('');
  const [jobdescription, setJobdescription] = useState('');
  const [startdate, setStartdate] = useState('');
  const [duedate, setDuedate] = useState('');
  const [selectedclient, setSelectedclient] = useState('');
  const [selectedclientname, setSelectedclientname] = useState('');

  const onSelected = (idSelVal, descSelVal) => {    
    setSelectedclient(idSelVal);
    setSelectedclientname(descSelVal);
  } 

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Click to see details of the item.
    </Tooltip>
  );  

  const onchangeJobTitle = (e) => {
    setJobtitle(e.target.value);
  } 

  const onChangeJobDescription = (e) => {
    setJobdescription(e.target.value);
  } 

  const onChangeJobStartDate = (e) => {
    setStartdate(e.target.value);
  } 
  
  const onChangeJobDueDate = (e) => {
    setDuedate(e.target.value);
  }   
  const handleValidations = (e) => {
    if (jobtitle.length == 0 || selectedclient.length == 0) {
      setErrmessage('There are empty required fields.');
      setShowerror(true);
      return;
    }
    saveJob();
  }

  useEffect(() => {
    retrieveJob(jobid);  
  }, [])

  const retrieveJob = (jobid) => {
    JobDataService.get(jobid)
      .then(response => {
        console.log(response.data);
        setJobid(response.data.id);
        setJobtitle(response.data.jobtitle);
        setJobdescription(response.data.jobdescription);
        setStartdate(response.data.jobstartdate);
        setDuedate(response.data.jobduedate);
        setSelectedclient(response.data.client?response.data.client.id:'');
        setSelectedclientname(response.data.client?response.data.client.clientname:'');
      })
      .catch(e => {
        console.log(e);
      });
  }


  let saveJob = ()  =>{   
    var data = {
        jobtitle: jobtitle,
        jobdescription: jobdescription,
        jobstartdate: startdate,
        jobduedate: duedate,
        clientId: selectedclient,
    }    
    
    JobDataService.update(params.id, data)
    .then(response => {
      setSubmitted(true);
      setSuccmessage('Job has been updated. Redirecting to job list...');
      setShowsuccess(true);
      //window.location.assign('/jobs'); if you set Submitte, then you don't need this line
    })
    .catch(e => {
      console.log(e);
    })        
  }  

  const goToJobsList = (e) => {
    window.location.assign('/jobs')
  }
  
  return (
    <>
      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"Edit Job: " + jobid}/>
        <div style={{padding:"0 8vw",}}>
            <Row className='md-3' lg={8}>
              <FormLabel className='mb-2'>Client:</FormLabel>       
            </Row>
            <Row className='md-3'>
              <FormControl style={{maxWidth:"300px"}} className='ms-2' type="text" name="client" id="client" disabled defaultValue={selectedclientname}></FormControl>
              <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip}>        
                  <SearchClient onSelected={onSelected}/>    
              </OverlayTrigger>
            </Row>


            <Col lg={true}>
              <FormLabel className='mb-2'>Job Title:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="jobtitle" id="e" onChange={onchangeJobTitle} defaultValue={jobtitle}></FormControl>
            </Col>

            <Col lg={true}>
              <FormLabel className='mb-2'>UOM Long Description:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="jobdescription" id="jobdescription" onChange={onChangeJobDescription} defaultValue={jobdescription}></FormControl>
            </Col>          

            <Col className='col-md-3' sm={8}>
              <FormLabel className='mb-2'>Start Date:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="date" name="jobstartdate" id="jobstartdate" onChange={onChangeJobStartDate} defaultValue={startdate?startdate.substring(0,10):''}></FormControl>
            </Col>  

            <Col className='col-md-3' sm={8}>
              <FormLabel className='mb-2'>Due Date:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="date" name="jobendduedate" id="jobendduedate" onChange={onChangeJobDueDate} defaultValue={duedate?duedate.substring(0,10):''}></FormControl>
            </Col>  

          <hr/>
          {showerror && (
            <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{errmessage}</p>
            </Alert>      
          )}
          {showsuccess && (
            <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
              <Alert.Heading>Done</Alert.Heading>
              <p>{succmessage}</p>
            </Alert>      
          )}     
          {submitted ? (<Navigate push to="/jobs"/>) : null }          
          <Row className='mb-2'>
            <Col className='col-md-3'>
              <Button id='saveItem' onClick={handleValidations}>Save Job</Button>            
              <Button className='m-2' id='backToJobssList' onClick={goToJobsList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>                                     
        </div>      
      </div>
    </>
  )

}

export default EditJobsPage;

